//
//
//
//
//

import Vue from "vue";
export default {
  name: "footerNav",
  props: {
  },
  computed: {
  },
  data: {
  },
  methods: {
  }
};



// WEBPACK FOOTER //
// ./src/components/footerNav.vue